import React from "react";
import "./App.css";
import FlickingList from "./FlickingList";
import LandingFooter from "./Footer";
import "./style/reset.css";
import WinLottie from "./WinLottie";

function App() {
  const invitationCode = new URLSearchParams(window.location.search).get(
    "code"
  );

  const url = `https://dominoapp.onelink.me/vY2c/xairufll?af_force_deeplink=true&inviteCode=${invitationCode}&deep_link_value=${invitationCode}`;

  return (
    <>
      <div
        className="AppWrapper"
        onClick={() => {
          window.location.href = url;
        }}
      >
        <WinLottie />
        <div className="App">
          <img src={"./images/content1.png"} className="bg" alt="logo" />
        </div>

        <div className="downloadWrapper">
          <FlickingList />
          <a className="downloadBoxWrapper" href={url}>
            <img
              src={"./images/downloadBox.png"}
              className="downloadBox"
              alt="logo"
            />
          </a>
        </div>
        <div className="bottom"></div>
      </div>
      <div style={{ padding: "20px" }}>
        <img src={"./images/FAQ.png"} className="footerBox" alt="logo" />
      </div>
      <img src={"./images/Footer.png"} className="footerBox" alt="logo" />
      <LandingFooter />
    </>
  );
}

export default App;
